const splitTimes = Array(10).fill(null);

splitTimes[0] = {
  name: "Nils Tveite",
  splits: [
    {
      control: 3,
      legTime: "9.43",
      legPos: 158,
      totalTime: "9.43",
      totalPos: 158,
    },
    {
      control: 4,
      legTime: "3.34",
      legPos: 5,
      totalTime: "13.17",
      totalPos: 127,
    },
    {
      control: 5,
      legTime: "0.35",
      legPos: 7,
      totalTime: "13.52",
      totalPos: 116,
    },
    {
      control: 11,
      legTime: "11.49",
      legPos: 23,
      totalTime: "25.41",
      totalPos: 51,
    },
    {
      control: 12,
      legTime: "5.16",
      legPos: 1,
      totalTime: "30.57",
      totalPos: 29,
    },
    {
      control: 13,
      legTime: "2.16",
      legPos: 1,
      totalTime: "33.13",
      totalPos: 26,
    },
    {
      control: 14,
      legTime: "1.18",
      legPos: 3,
      totalTime: "34.31",
      totalPos: 25,
    },
    {
      control: 16,
      legTime: "7.41",
      legPos: 27,
      totalTime: "42.12",
      totalPos: 18,
    },
    {
      control: 18,
      legTime: "3.41",
      legPos: 43,
      totalTime: "45.53",
      totalPos: 17,
    },
    {
      control: 19,
      legTime: "1.46",
      legPos: 119,
      totalTime: "47.39",
      totalPos: 22,
    },
    {
      control: 20,
      legTime: "0.32",
      legPos: 12,
      totalTime: "48.11",
      totalPos: 20,
    },
    {
      control: "mål",
      legTime: "0.31",
      legPos: 59,
      totalTime: "48.42",
      totalPos: 20,
    },
  ],
};

splitTimes[1] = {
  name: "Albin Warvelin",
  splits: [
    {
      control: 3,
      legTime: "7.50",
      legPos: 7,
      totalTime: "7.50",
      totalPos: 7,
    },
    {
      control: 4,
      legTime: "3.44",
      legPos: 2,
      totalTime: "11.34",
      totalPos: 4,
    },
    {
      control: 5,
      legTime: "0.37",
      legPos: 109,
      totalTime: "12.11",
      totalPos: 6,
    },
    {
      control: 11,
      legTime: "12.05",
      legPos: 31,
      totalTime: "24.16",
      totalPos: 10,
    },
    {
      control: 12,
      legTime: "8.21",
      legPos: 10,
      totalTime: "32.37",
      totalPos: 6,
    },
    {
      control: 13,
      legTime: "1.22",
      legPos: 11,
      totalTime: "33.59",
      totalPos: 6,
    },
    {
      control: 15,
      legTime: "3.36",
      legPos: 38,
      totalTime: "37.35",
      totalPos: 7,
    },
    {
      control: 16,
      legTime: "1.35",
      legPos: 183,
      totalTime: "39.10",
      totalPos: 14,
    },
    {
      control: 17,
      legTime: "0.57",
      legPos: 4,
      totalTime: "40.07",
      totalPos: 14,
    },
    {
      control: "mål",
      legTime: "0.31",
      legPos: 18,
      totalTime: "40.38",
      totalPos: 13,
    },
  ],
};

splitTimes[2] = {
  name: "Sigurd Paulsen Vie",
  splits: [
    {
      control: 3,
      legTime: "7.46",
      legPos: 15,
      totalTime: "7.46",
      totalPos: 15,
    },
    {
      control: 4,
      legTime: "3.11",
      legPos: 3,
      totalTime: "10.57",
      totalPos: 9,
    },
    {
      control: 5,
      legTime: "0.30",
      legPos: 1,
      totalTime: "11.27",
      totalPos: 8,
    },
    {
      control: 11,
      legTime: "12.03",
      legPos: 32,
      totalTime: "23.30",
      totalPos: 16,
    },
    {
      control: 13,
      legTime: "5.09",
      legPos: 5,
      totalTime: "28.39",
      totalPos: 13,
    },
    {
      control: 14,
      legTime: "2.17",
      legPos: 24,
      totalTime: "30.56",
      totalPos: 11,
    },
    {
      control: 15,
      legTime: "0.42",
      legPos: 8,
      totalTime: "31.38",
      totalPos: 11,
    },
    {
      control: 17,
      legTime: "6.46",
      legPos: 3,
      totalTime: "38.24",
      totalPos: 10,
    },
    {
      control: 18,
      legTime: "2.16",
      legPos: 4,
      totalTime: "40.40",
      totalPos: 10,
    },
    {
      control: 19,
      legTime: "1.10",
      legPos: 7,
      totalTime: "41.50",
      totalPos: 10,
    },
    {
      control: 20,
      legTime: "0.32",
      legPos: 12,
      totalTime: "42.22",
      totalPos: 10,
    },
    {
      control: "mål",
      legTime: "0.30",
      legPos: 13,
      totalTime: "42.52",
      totalPos: 10,
    },
  ],
};

splitTimes[3] = {
  name: "Mats Eidsmo",
  splits: [
    {
      control: 1,
      legTime: "6.45",
      legPos: 21,
      totalTime: "6.45",
      totalPos: 21,
    },
    {
      control: 2,
      legTime: "11.38",
      legPos: 37,
      totalTime: "18.23",
      totalPos: 23,
    },
    {
      control: 3,
      legTime: "1.33",
      legPos: 168,
      totalTime: "19.56",
      totalPos: 26,
    },
    {
      control: 4,
      legTime: "15.12",
      legPos: 35,
      totalTime: "35.08",
      totalPos: 24,
    },
    {
      control: 5,
      legTime: "0.47",
      legPos: 7,
      totalTime: "35.55",
      totalPos: 24,
    },
    {
      control: 6,
      legTime: "1.05",
      legPos: 15,
      totalTime: "37.00",
      totalPos: 23,
    },
    {
      control: 7,
      legTime: "0.50",
      legPos: 25,
      totalTime: "37.50",
      totalPos: 22,
    },
    {
      control: 8,
      legTime: "9.02",
      legPos: 22,
      totalTime: "46.52",
      totalPos: 25,
    },
    {
      control: 9,
      legTime: "0.48",
      legPos: 131,
      totalTime: "47.40",
      totalPos: 25,
    },
    {
      control: 10,
      legTime: "4.25",
      legPos: 82,
      totalTime: "52.05",
      totalPos: 25,
    },
    {
      control: 11,
      legTime: "1.34",
      legPos: 29,
      totalTime: "53.39",
      totalPos: 24,
    },
    {
      control: 12,
      legTime: "5.43",
      legPos: 52,
      totalTime: "59.22",
      totalPos: 24,
    },
    {
      control: 13,
      legTime: "2.29",
      legPos: 52,
      totalTime: "1:01.51",
      totalPos: 25,
    },
    {
      control: 14,
      legTime: "1.00",
      legPos: 20,
      totalTime: "1:02.51",
      totalPos: 24,
    },
    {
      control: 15,
      legTime: "3.52",
      legPos: 10,
      totalTime: "1:06.43",
      totalPos: 23,
    },
    {
      control: 16,
      legTime: "1.07",
      legPos: 24,
      totalTime: "1:07.50",
      totalPos: 22,
    },
    {
      control: 17,
      legTime: "24.50",
      legPos: 1,
      totalTime: "1:32.40",
      totalPos: 16,
    },
    {
      control: 18,
      legTime: "0.35",
      legPos: 22,
      totalTime: "1:33.15",
      totalPos: 15,
    },
    {
      control: 19,
      legTime: "1.34",
      legPos: 1,
      totalTime: "1:34.49",
      totalPos: 15,
    },
    {
      control: 20,
      legTime: "1.52",
      legPos: 6,
      totalTime: "1:36.41",
      totalPos: 15,
    },
    {
      control: "mål",
      legTime: "0.30",
      legPos: 3,
      totalTime: "1:37.11",
      totalPos: 15,
    },
  ],
};

splitTimes[4] = {
  name: "Oskar Edvardsson",
  splits: [
    {
      control: 2,
      legTime: "5.40",
      legPos: 36,
      totalTime: "5.40",
      totalPos: 36,
    },
    {
      control: 4,
      legTime: "5.12",
      legPos: 2,
      totalTime: "10.52",
      totalPos: 12,
    },
    {
      control: 5,
      legTime: "0.55",
      legPos: 24,
      totalTime: "11.47",
      totalPos: 10,
    },
    {
      control: 6,
      legTime: "1.10",
      legPos: 20,
      totalTime: "12.57",
      totalPos: 10,
    },
    {
      control: 7,
      legTime: "0.38",
      legPos: 33,
      totalTime: "13.35",
      totalPos: 9,
    },
    {
      control: 8,
      legTime: "2.49",
      legPos: 10,
      totalTime: "16.24",
      totalPos: 8,
    },
    {
      control: 9,
      legTime: "1.59",
      legPos: 26,
      totalTime: "18.23",
      totalPos: 10,
    },
    {
      control: 13,
      legTime: "8.56",
      legPos: 12,
      totalTime: "27.19",
      totalPos: 6,
    },
    {
      control: 14,
      legTime: "1.00",
      legPos: 13,
      totalTime: "28.19",
      totalPos: 6,
    },
    {
      control: 17,
      legTime: "8.30",
      legPos: 29,
      totalTime: "36.49",
      totalPos: 17,
    },
    {
      control: 18,
      legTime: "1.38",
      legPos: 2,
      totalTime: "38.27",
      totalPos: 14,
    },
    {
      control: 19,
      legTime: "1.06",
      legPos: 8,
      totalTime: "39.33",
      totalPos: 12,
    },
    {
      control: 20,
      legTime: "0.29",
      legPos: 1,
      totalTime: "40.02",
      totalPos: 11,
    },
    {
      control: "mål",
      legTime: "0.28",
      legPos: 1,
      totalTime: "40.30",
      totalPos: 10,
    },
  ],
};

splitTimes[5] = {
  name: "Vegard Gulbrandsen",
  splits: [
    {
      control: 2,
      legTime: "4.56",
      legPos: 2,
      totalTime: "4.56",
      totalPos: 2,
    },
    {
      control: 4,
      legTime: "5.19",
      legPos: 13,
      totalTime: "10.15",
      totalPos: 5,
    },
    {
      control: 5,
      legTime: "0.59",
      legPos: 12,
      totalTime: "11.14",
      totalPos: 5,
    },
    {
      control: 6,
      legTime: "0.56",
      legPos: 12,
      totalTime: "12.10",
      totalPos: 5,
    },
    {
      control: 7,
      legTime: "3.25",
      legPos: 8,
      totalTime: "15.35",
      totalPos: 3,
    },
    {
      control: 8,
      legTime: "1.26",
      legPos: 79,
      totalTime: "17.01",
      totalPos: 5,
    },
    {
      control: 9,
      legTime: "2.34",
      legPos: 6,
      totalTime: "19.35",
      totalPos: 6,
    },
    {
      control: 13,
      legTime: "9.29",
      legPos: 19,
      totalTime: "29.04",
      totalPos: 8,
    },
    {
      control: 14,
      legTime: "1.43",
      legPos: 268,
      totalTime: "30.47",
      totalPos: 9,
    },
    {
      control: 17,
      legTime: "8.05",
      legPos: 20,
      totalTime: "38.52",
      totalPos: 10,
    },
    {
      control: 18,
      legTime: "1.16",
      legPos: 10,
      totalTime: "40.08",
      totalPos: 10,
    },
    {
      control: 19,
      legTime: "1.31",
      legPos: 4,
      totalTime: "41.39",
      totalPos: 10,
    },
    {
      control: 20,
      legTime: "0.32",
      legPos: 3,
      totalTime: "42.11",
      totalPos: 10,
    },
    {
      control: "mål",
      legTime: "0.32",
      legPos: 8,
      totalTime: "42.43",
      totalPos: 9,
    },
  ],
};

splitTimes[6] = {
  name: "Anders Vestøl",
  splits: [
    {
      control: 2,
      legTime: "5.41",
      legPos: 33,
      totalTime: "5.41",
      totalPos: 33,
    },
    {
      control: 4,
      legTime: "5.39",
      legPos: 20,
      totalTime: "11.20",
      totalPos: 18,
    },
    {
      control: 5,
      legTime: "0.36",
      legPos: 3,
      totalTime: "11.56",
      totalPos: 13,
    },
    {
      control: 6,
      legTime: "2.15",
      legPos: 29,
      totalTime: "14.11",
      totalPos: 14,
    },
    {
      control: 10,
      legTime: "9.12",
      legPos: 16,
      totalTime: "23.23",
      totalPos: 16,
    },
    {
      control: 11,
      legTime: "0.58",
      legPos: 11,
      totalTime: "24.21",
      totalPos: 15,
    },
    {
      control: 12,
      legTime: "2.08",
      legPos: 3,
      totalTime: "26.29",
      totalPos: 8,
    },
    {
      control: 13,
      legTime: "3.04",
      legPos: 3,
      totalTime: "29.33",
      totalPos: 6,
    },
    {
      control: 14,
      legTime: "1.26",
      legPos: 2,
      totalTime: "30.59",
      totalPos: 5,
    },
    {
      control: 15,
      legTime: "1.33",
      legPos: 2,
      totalTime: "32.32",
      totalPos: 5,
    },
    {
      control: 16,
      legTime: "1.13",
      legPos: 14,
      totalTime: "33.45",
      totalPos: 5,
    },
    {
      control: 17,
      legTime: "0.29",
      legPos: 1,
      totalTime: "34.14",
      totalPos: 5,
    },
    {
      control: "mål",
      legTime: "0.30",
      legPos: 2,
      totalTime: "34.44",
      totalPos: 5,
    },
  ],
};

splitTimes[7] = {
  name: "Sander Arntzen",
  splits: [
    {
      control: 1,
      legTime: "3.39",
      legPos: 2,
      totalTime: "3.39",
      totalPos: 2,
    },
    {
      control: 2,
      legTime: "5.38",
      legPos: 4,
      totalTime: "9.17",
      totalPos: 3,
    },
    {
      control: 3,
      legTime: "4.25",
      legPos: 13,
      totalTime: "13.42",
      totalPos: 4,
    },
    {
      control: 4,
      legTime: "2.29",
      legPos: 15,
      totalTime: "16.11",
      totalPos: 4,
    },
    {
      control: 5,
      legTime: "1.51",
      legPos: 272,
      totalTime: "18.02",
      totalPos: 15,
    },
    {
      control: 6,
      legTime: "2.37",
      legPos: 8,
      totalTime: "20.39",
      totalPos: 13,
    },
    {
      control: 7,
      legTime: "2.08",
      legPos: 8,
      totalTime: "22.47",
      totalPos: 11,
    },
    {
      control: 8,
      legTime: "11.31",
      legPos: 11,
      totalTime: "34.18",
      totalPos: 7,
    },
    {
      control: 9,
      legTime: "4.43",
      legPos: 6,
      totalTime: "39.01",
      totalPos: 6,
    },
    {
      control: 10,
      legTime: "1.45",
      legPos: 13,
      totalTime: "40.46",
      totalPos: 5,
    },
    {
      control: 11,
      legTime: "2.01",
      legPos: 16,
      totalTime: "42.47",
      totalPos: 4,
    },
    {
      control: 12,
      legTime: "2.51",
      legPos: 14,
      totalTime: "45.38",
      totalPos: 5,
    },
    {
      control: 13,
      legTime: "2.56",
      legPos: 3,
      totalTime: "48.34",
      totalPos: 5,
    },
    {
      control: 14,
      legTime: "1.29",
      legPos: 10,
      totalTime: "50.03",
      totalPos: 5,
    },
    {
      control: 15,
      legTime: "5.33",
      legPos: 4,
      totalTime: "55.36",
      totalPos: 3,
    },
    {
      control: 16,
      legTime: "1.42",
      legPos: 69,
      totalTime: "57.18",
      totalPos: 3,
    },
    {
      control: 17,
      legTime: "2.03",
      legPos: 61,
      totalTime: "59.21",
      totalPos: 3,
    },
    {
      control: 18,
      legTime: "3.53",
      legPos: 4,
      totalTime: "1:03.14",
      totalPos: 3,
    },
    {
      control: 19,
      legTime: "1.49",
      legPos: 2,
      totalTime: "1:05.03",
      totalPos: 3,
    },
    {
      control: 20,
      legTime: "1.57",
      legPos: 17,
      totalTime: "1:07.00",
      totalPos: 3,
    },
    {
      control: "mål",
      legTime: "0.32",
      legPos: 17,
      totalTime: "1:07.32",
      totalPos: 3,
    },
  ],
};

splitTimes[8] = {
  name: "Isak Jonsson",
  splits: [
    {
      control: 1,
      legTime: "11.35",
      legPos: 2,
      totalTime: "11.35",
      totalPos: 2,
    },
    {
      control: 4,
      legTime: "15.23",
      legPos: 5,
      totalTime: "26.58",
      totalPos: 4,
    },
    {
      control: 5,
      legTime: "5.33",
      legPos: 4,
      totalTime: "32.31",
      totalPos: 1,
    },
    {
      control: 7,
      legTime: "1.39",
      legPos: 97,
      totalTime: "34.10",
      totalPos: 1,
    },
    {
      control: 8,
      legTime: "1.03",
      legPos: 3,
      totalTime: "35.13",
      totalPos: 1,
    },
    {
      control: 9,
      legTime: "4.38",
      legPos: 11,
      totalTime: "39.51",
      totalPos: 1,
    },
    {
      control: 10,
      legTime: "2.41",
      legPos: 12,
      totalTime: "42.32",
      totalPos: 2,
    },
    {
      control: 11,
      legTime: "1.48",
      legPos: 6,
      totalTime: "44.20",
      totalPos: 2,
    },
    {
      control: 14,
      legTime: "13.12",
      legPos: 4,
      totalTime: "57.32",
      totalPos: 2,
    },
    {
      control: 16,
      legTime: "3.42",
      legPos: 3,
      totalTime: "1:01.14",
      totalPos: 2,
    },
    {
      control: 17,
      legTime: "5.28",
      legPos: 3,
      totalTime: "1:06.42",
      totalPos: 3,
    },
    {
      control: 18,
      legTime: "7.31",
      legPos: 6,
      totalTime: "1:14.13",
      totalPos: 1,
    },
    {
      control: 19,
      legTime: "1.52",
      legPos: 7,
      totalTime: "1:16.05",
      totalPos: 1,
    },
    {
      control: 20,
      legTime: "1.05",
      legPos: 4,
      totalTime: "1:17.10",
      totalPos: 2,
    },
    {
      control: 21,
      legTime: "0.56",
      legPos: 6,
      totalTime: "1:18.06",
      totalPos: 2,
    },
    {
      control: 22,
      legTime: "0.57",
      legPos: 2,
      totalTime: "1:19.03",
      totalPos: 2,
    },
    {
      control: "mål",
      legTime: "0.33",
      legPos: 34,
      totalTime: "1:19.36",
      totalPos: 2,
    },
  ],
};

splitTimes[9] = {
  name: "Eirik Langedal Breivik",
  splits: [
    {
      control: 1,
      legTime: "10.47",
      legPos: 3,
      totalTime: "10.47",
      totalPos: 3,
    },
    {
      control: 4,
      legTime: "13.25",
      legPos: 3,
      totalTime: "24.12",
      totalPos: 2,
    },
    {
      control: 6,
      legTime: "4.54",
      legPos: 5,
      totalTime: "29.06",
      totalPos: 1,
    },
    {
      control: 7,
      legTime: "1.06",
      legPos: 6,
      totalTime: "30.12",
      totalPos: 1,
    },
    {
      control: 8,
      legTime: "5.01",
      legPos: 12,
      totalTime: "35.13",
      totalPos: 1,
    },
    {
      control: 9,
      legTime: "1.33",
      legPos: 9,
      totalTime: "36.46",
      totalPos: 1,
    },
    {
      control: 10,
      legTime: "1.00",
      legPos: 1,
      totalTime: "37.46",
      totalPos: 1,
    },
    {
      control: 11,
      legTime: "2.59",
      legPos: 14,
      totalTime: "40.45",
      totalPos: 1,
    },
    {
      control: 12,
      legTime: "3.25",
      legPos: 20,
      totalTime: "44.10",
      totalPos: 1,
    },
    {
      control: 13,
      legTime: "1.00",
      legPos: 13,
      totalTime: "45.10",
      totalPos: 2,
    },
    {
      control: 14,
      legTime: "1.16",
      legPos: 3,
      totalTime: "46.26",
      totalPos: 2,
    },
    {
      control: 17,
      legTime: "11.38",
      legPos: 1,
      totalTime: "58.04",
      totalPos: 1,
    },
    {
      control: 19,
      legTime: "3.24",
      legPos: 9,
      totalTime: "1:01.28",
      totalPos: 2,
    },
    {
      control: 20,
      legTime: "5.53",
      legPos: 2,
      totalTime: "1:07.21",
      totalPos: 2,
    },
    {
      control: 21,
      legTime: "4.19",
      legPos: 2,
      totalTime: "1:11.40",
      totalPos: 2,
    },
    {
      control: 22,
      legTime: "4.03",
      legPos: 11,
      totalTime: "1:15.43",
      totalPos: 2,
    },
    {
      control: 23,
      legTime: "1.13",
      legPos: 8,
      totalTime: "1:16.56",
      totalPos: 2,
    },
    {
      control: 24,
      legTime: "1.28",
      legPos: 29,
      totalTime: "1:18.24",
      totalPos: 2,
    },
    {
      control: "mål",
      legTime: "0.54",
      legPos: 312,
      totalTime: "1:19.18",
      totalPos: 2,
    },
  ],
};

const legSplits = [
  [
    "1. Nils Tveite",
    "48:42", // Etappetid
    "20", // Etappeplass
    "+1:15", // Etappediff
    "48:42", // Tid
    "20", // Plass
    "0", // Endring (Started first leg, no position change)
    "+1:15", // Diff
  ],
  ["2. Albin Warvelin", "40:38", "13", "+1:28", "1:29:20", "13", "-7", "+0:46"],
  [
    "3. Sigurd Paulsen Vie",
    "42:52",
    "10",
    "+2:48",
    "2:12:12",
    "6",
    "-7",
    "+0:56",
  ],
  ["4. Mats Eidsmo", "1:37:11", "15", "+2:53", "3:49:23", "2", "-4", "+0:02"],
  ["5. Oskar Edvardsson", "40:30", "10", "+2:03", "4:29:53", "2", "0", "+0:06"],
  [
    "6. Vegard Gulbrandsen",
    "42:43",
    "9",
    "+3:21",
    "5:12:36",
    "6",
    "+4",
    "+1:19",
  ],
  ["7. Anders Vestøl", "34:44", "5", "+3:57", "5:47:20", "5", "-1", "+2:52"],
  ["8. Sander Arntzen", "1:07:32", "3", "+1:24", "6:54:52", "6", "+1", "+3:28"],
  ["9. Isak Jonsson", "1:19:36", "2", "+0:10", "8:14:28", "2", "-4", "+0:11"],
  [
    "10. Eirik Langedal Breivik",
    "1:19:18",
    "2",
    "+0:38",
    "9:33:46",
    "1",
    "-1",
    "-0:11",
  ],
];

export { splitTimes, legSplits };
